/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataModuleExcludingId } from '../models/data-module-excluding-id';
import { DataModuleExcludingIdWithRelations } from '../models/data-module-excluding-id-with-relations';
import { DataModulePartialExcludingIdCreationInfoUpdateInfo } from '../models/data-module-partial-excluding-id-creation-info-update-info';
import { DataModuleWithRelations } from '../models/data-module-with-relations';
import { NewModule } from '../models/new-module';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({ providedIn: 'root' })
export class DataModuleControllerService extends DataBaseService {

  /**
   * Path part for operation dataModuleControllerCount
   */
  static readonly DataModuleControllerCountPath = '/v1/data-module/count';

  /**
   * Get total modules in the system
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
    includeCoreModule?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, DataModuleControllerService.DataModuleControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
      rb.query('includeCoreModule', params.includeCoreModule, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Get total modules in the system
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
    includeCoreModule?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation dataModuleControllerFindById
   */
  static readonly DataModuleControllerFindByIdPath = '/v1/data-module/{id}';

  /**
   * Get module by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<DataModuleExcludingIdWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, DataModuleControllerService.DataModuleControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataModuleExcludingIdWithRelations>;
      })
    );
  }
  /**
   * Get module by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<DataModuleExcludingIdWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<DataModuleExcludingIdWithRelations>) => r.body as DataModuleExcludingIdWithRelations)
    );
  }

  /**
   * Path part for operation dataModuleControllerDeleteById
   */
  static readonly DataModuleControllerDeleteByIdPath = '/v1/data-module/{id}';

  /**
   * Delete module by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataModuleControllerService.DataModuleControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Delete module by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataModuleControllerUpdateById
   */
  static readonly DataModuleControllerUpdateByIdPath = '/v1/data-module/{id}';

  /**
   * Update module by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: DataModulePartialExcludingIdCreationInfoUpdateInfo
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataModuleControllerService.DataModuleControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Update module by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: DataModulePartialExcludingIdCreationInfoUpdateInfo
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataModuleControllerFind
   */
  static readonly DataModuleControllerFindPath = '/v1/data-module';

  /**
   * Get all modules
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
    includeCoreModule?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataModuleWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, DataModuleControllerService.DataModuleControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
      rb.query('includeCoreModule', params.includeCoreModule, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataModuleWithRelations>>;
      })
    );
  }
  /**
   * Get all modules
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
    includeCoreModule?: boolean;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataModuleWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataModuleWithRelations>>) => r.body as Array<DataModuleWithRelations>)
    );
  }

  /**
   * Path part for operation dataModuleControllerCreate
   */
  static readonly DataModuleControllerCreatePath = '/v1/data-module';

  /**
   * Create new module
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewModule
  }): Observable<StrictHttpResponse<DataModuleExcludingId>> {

    const rb = new RequestBuilder(this.rootUrl, DataModuleControllerService.DataModuleControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataModuleExcludingId>;
      })
    );
  }
  /**
   * Create new module
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewModule
  }): Observable<DataModuleExcludingId> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<DataModuleExcludingId>) => r.body as DataModuleExcludingId)
    );
  }

}
